import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route,  } from 'react-router-dom';
import Form from './user/Form';


// Admin imports
 import Dashboard from './admin/Dashboard';
 import Sidebar from './admin/Sidebar';
 import ApplicationFormReport from './admin/ApplicationFormReport';



const App = () => {
  

  return (
   
      <BrowserRouter>
      <Routes>

          {/* User Panel (Default Route) */}
          <Route path='/' element={<Form />}>
           


          </Route>

          {/* Admin Panel */}
          <Route path='/admin' element={<Sidebar />}>
            <Route index element={<Dashboard />} />
            <Route path='applicationformreport' element={<ApplicationFormReport />} />

            



          </Route>
          </Routes>
     </BrowserRouter>
    
  );
}

export default App;
